import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const ActivityPriceFragment = graphql(
  `
    fragment ActivityPrice on Activity {
      price {
        token {
          unit
        }
        ...TokenPrice
      }
      from {
        address
      }
      to {
        address
      }
      ... on Sale {
        saleType
      }
    }
  `,
  [TokenPriceFragment],
)
